<template>
  <div class="w-full pointer-events-none">
    <svg class="w-full fill-transparent -scale-y-100" viewBox="-10 -10 140 80">
      <path
        class="statDot duration-300"
        stroke-linejoin="round"
        :d="
          stats
            .map(
              (val, i) =>
                `${i == 0 ? 'M' : 'L'}${(i * 120) / stats.length},${(val * 60) / maxValueToUse || 0}`,
            )
            .join(' ') + ' L112,-10 L-0,-10 L-0,0'
        "
        style="mask-image: linear-gradient(to bottom, transparent 20%, black)"
      />
      <path
        class="statLine stroke-primary stroke-1 duration-300"
        stroke-linejoin="round"
        :d="
          stats
            .map(
              (val, i) =>
                `${i == 0 ? 'M' : 'L'}${(i * 120) / stats.length},${(val * 60) / maxValueToUse || 0}`,
            )
            .join(' ') 
        "
      />
      <circle
        class="statDot fill-primary stroke-transparent stroke-[4] relative z-[2] hover:z-[1] duration-300 pointer-events-auto"
        v-for="(val, i) in stats"
        :cx="(i * 120) / stats.length"
        :cy="(val * 60) / maxValueToUse"
        r="0.5"
        onmouseover="evt.target.setAttribute('r', '5');"
        onmouseout="evt.target.setAttribute('r', '0.5');"
        @mouseover="hoveredStatPoint(val, i)"
        @mouseout="outFromStatPoint()"
        :key="i"
      />
    </svg>
  </div>
</template>

<script>
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'PlatformStats',
  components: {},
  props: {
    stats: {
      type: Array,
      default: () => {
        return []
      },
    },
    maxValue: {
      type: Number,
      default: () => {
        return 0
      },
    },
  },
  data() {
    return {}
  },
  mounted() {},
  methods: {
    selectPeriod(period) {
      this.selectedPeriod = period.id
    },
    hoveredStatPoint(value, position) {
      this.$emit('hoveredStatPoint', { value, position })
    },
    outFromStatPoint() {
      this.$emit('outFromStatPoint')
    },
  },
  computed: {
    maxValueToUse() {
      return this.maxValue || Math.max(...this.stats)
    },
    totalValue() {
      let total = 0
      this.stats.forEach(val => (total += val))
      return total
    },
  },
})
</script>
